<template>
  <vx-card :title="title">
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="false" color="#007BFF" loader="dots"></loading>

    <template slot="actions">
      <!-- <region-dropdown v-on:onRegionChanged="lc" />
      &nbsp; -->
      <chart-type-dropdown v-on:onCTChanged="ctc" />
      <!-- <chart-filter v-on:updated="filterChanged" /> -->
    </template>
    <vue-apex-charts type="line" height="350" :options="barChart.chartOptions" :series="barChart.series"></vue-apex-charts>
  </vx-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import is from 'is_js'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

import ChartFilter from '@/components/filters/ChartFilter'
import RegionDropdown from '../dropdowns/RegionDropdown.vue'
import ChartTypeDropdown from '../dropdowns/ChartTypeDropdown.vue'

import covidApi from '@/http/requests/covid/index.js'

export default {
  name: 'MainBarChart',
  components: {
    VueApexCharts,
    Loading,
    ChartFilter,
    RegionDropdown,
    ChartTypeDropdown
  },
  watch: {
    barType() {
      this.updateChart()
    },
    params() {
      if (this.updateData) {
        this.getData()
      } else {
        this.updateChart()
      }
    }
  },
  computed: {
    title() {
      return `SARS-CoV-2 Variants${this.region === '' || this.region === 'All' ? '' : `: ${this.region}`}`
    }
  },
  data() {
    return {
      barChart: {
        series: [],
        chartOptions: {
          colors: ['#008cff', '#28C76F', '#EA5455', '#7193FF', '#FF9F43', '#e5ff00', '#1E1E1E', '#4b9484', '#af9d6a'],
          chart: {
            stacked: true,
            toolbar: { show: false },
            dropShadow: {
              enabled: false,
              top: 5,
              left: 0,
              blur: 4,
              opacity: 0.1
            }
          },
          noData: {
            text: ''
          },
          grid: {
            borderColor: '#e7e7e7'
          },
          stroke: {
            width: 0.8,
            curve: 'smooth'
          },
          plotOptions: {
            bar: {
              columnWidth: '20%'
            }
          },

          fill: {
            opacity: 0.8
          },
          labels: [],
          markers: {
            size: 0
          },
          xaxis: {
            type: 'datetime',
            axisBorder: {
              show: false
            }
          },
          yaxis: {
            title: {
              text: '# of Samples Sequenced'
            },
            min: 0
          },
          tooltip: {
            shared: true,
            intersect: false,
            y: {
              formatter(y) {
                if (typeof y !== 'undefined') {
                  return `${y.toFixed(0)} samples`
                }
                return y
              }
            }
          }
        }
      },
      barType: 'column',
      labels: [],
      series: [],
      params: { country: 'Ghana', region: 'All', town: 'All', start: '2020-03-01', end: new Date().toISOString().slice(0, 10) },
      region: '',
      updateData: true,
      isLoading: false
    }
  },
  created() {
    this.getData()
  },
  methods: {
    lc(r) {
      this.region = r
      this.params.region = r
      this.getData()
    },
    ctc(v) {
      this.barType = v
    },
    getData() {
      this.series = []
      this.updateChart()
      this.isLoading = true
      covidApi
        .chartData(this.params)
        .then(response => {
          // console.log(response.data)
          this.series = response.data.series
          this.labels = response.data.labels
          this.updateData = false
          this.updateChart()
        })
        .catch(error => {
          console.log(error)
        })
    },
    updateChart() {
      const l = this.setLabels()
      const s = this.setSeries()

      this.barChart.series = s
      this.barChart.chartOptions = {
        ...this.barChart.chartOptions,
        series: s,
        labels: l
      }
      this.isLoading = false
    },
    setLabels() {
      const self = this
      const l = is.not.undefined(this.labels) ? JSON.parse(JSON.stringify(this.labels)) : []
      const x = l.filter(function(l) {
        return self.betweenDates(self.params.start, self.params.end, l)
      })
      // console.log(`Length ${x.length}`)
      // console.log(`Start: ${x[0]} End: ${x[x.length - 1]}`)
      return x
    },
    setSeries() {
      const self = this
      const s = is.not.undefined(this.series) ? JSON.parse(JSON.stringify(this.series)) : []
      const sIdx = self.labels.findIndex(d => {
        return d === self.params.start
      })
      let eIdx = self.labels.findIndex(d => {
        return d === self.params.end
      })
      eIdx = eIdx === 0 ? 1 : eIdx
      // console.log(`sIdx: ${sIdx} eIdx: ${eIdx}`)
      return s.map(function(y) {
        y.type = self.barType
        if (sIdx !== -1 && eIdx !== -1) {
          y.data = y.data.slice(sIdx, eIdx + 1)
        }
        // console.log(`Sample length ${y.data.length}`)
        return y
      })
    },
    betweenDates(dateFrom, dateTo, dateCheck) {
      const d1 = dateFrom.split('-')
      const d2 = dateTo.split('-')
      const c = dateCheck.split('-')

      const from = new Date(d1[0], parseInt(d1[1]) - 1, d1[2]) // -1 because months are from 0 to 11
      const to = new Date(d2[0], parseInt(d2[1]) - 1, d2[2])
      const check = new Date(c[0], parseInt(c[1]) - 1, c[2])

      return check >= from && check <= to
    },
    filterChanged(args) {
      if (this.params.region !== args.region) {
        this.updateData = true
      }
      this.params = args
    }
  }
}
</script>
